<template>
    <div>
        <div v-if="!loading">
            <v-btn
                v-if="(id && can('api.v1.pharmacy-groups.update')) || (!id && can('api.v1.pharmacy-groups.store'))"
                color="primary"
                rounded
                :loading="pharmacyGroupsFormLoading"
                :disabled="disabled"
                class="ml-4"
                large
                @click="save()"
            >
                {{
                    isAdmin ? t('pharmacy-groups::button.submit') : t('pharmacy-groups::button.send_save_request')
                }}</v-btn
            >
        </div>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            pharmacyGroupsFormLoading: false,
        };
    },
    computed: {
        id() {
            return this.$store.state.pharmacy_groups.pharmacy_group.id;
        },
        isAdmin() {
            return User.group === 'admins';
        },
    },
    methods: {
        async save() {
            this.pharmacyGroupsFormLoading = true;
            this.$store.dispatch('pharmacy_groups/resetErrorMessages');
            axios({
                method: this.id ? 'put' : 'post',
                url: this.id
                    ? route('api.v1.pharmacy-groups.update', { pharmacy_group: this.id })
                    : route('api.v1.pharmacy-groups.store'),
                data: this.$store.state.pharmacy_groups.pharmacy_group,
            })
                .then(() => {
                    _.delay(() => {
                        this.$root.goTo(route('pharmacy-groups.index'));
                    }, 1000);
                    if (!this.id) {
                        if (this.isAdmin) {
                            return this.$root.notify(
                                'info',
                                t('pharmacy-groups::notification.success'),
                                t('pharmacy-groups::notification.pharmacy_groups.created')
                            );
                        } else {
                            return this.$root.notify(
                                'info',
                                t('pharmacy-groups::notification.success'),
                                t('pharmacy-groups::notification.pharmacy_groups.send_approval')
                            );
                        }
                    }
                    if (this.id) {
                        if (this.isAdmin) {
                            return this.$root.notify(
                                'info',
                                t('pharmacy-groups::notification.success'),
                                t('pharmacy-groups::notification.pharmacy_groups.update')
                            );
                        } else {
                            return this.$root.notify(
                                'info',
                                t('pharmacy-groups::notification.success'),
                                t('pharmacy-groups::notification.pharmacy_groups.send_approval')
                            );
                        }
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('pharmacy_groups/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => _.delay(() => (this.pharmacyGroupsFormLoading = false), 1400));
        },
    },
};
</script>

<style></style>
